export const mockData = {
  products: [
    {
      id: 1,
      name: 'Teja S17',
      subtitle: 'Premium Heat Variety',
      description: 'High spicy with thin skin, whole pods. Premium export grade with maximum heat retention.',
      image: '/teja_s17.jpg',
      heatLevel: '75,000-100,000 SHU',
      color: '40-60 ASTA',
      moisture: '≤14%',
      origin: 'Guntur, Andhra Pradesh',
      specifications: ['Thin skin', 'Whole pods', 'High pungency', '0.50-0.70% Capsaicin']
    },
    {
      id: 2,
      name: 'Byadgi (5531)',
      subtitle: 'Premium Color Variety',
      description: 'Less pungent with exceptional color. Dark & bright red with wrinkled thick skin.',
      image: '/byadgi_5531.jpg',
      heatLevel: '12,000-17,000 SHU',
      color: '100-140 ASTA',
      moisture: '≤14%',
      origin: 'Karnataka',
      specifications: ['Thick skin', 'Wrinkled', 'Dark red', 'Fewer seeds']
    },
    {
      id: 3,
      name: 'Sanam S334',
      subtitle: 'Medium Heat Variety',
      description: 'Medium spicy with bright red color. Thin skin, perfect for curries and culinary use.',
      image: '/sanam_s334.jpg',
      heatLevel: '18,000-22,000 SHU',
      color: '40-50 ASTA',
      moisture: '≤14%',
      origin: 'Guntur, Andhra Pradesh',
      specifications: ['Thin skin', 'Medium size', '9-12cm length', 'Bright red']
    },
    {
      id: 4,
      name: 'Endo 5 (C5)',
      subtitle: 'Premium Blood Red',
      description: 'Medium pungent with exceptional blood red color. Thick skin for premium appearance.',
      image: '/endo_c5.jpg',
      heatLevel: '50,000-60,000 SHU',
      color: '60-120 ASTA',
      moisture: '≤14%',
      origin: 'Guntur, Andhra Pradesh',
      specifications: ['Thick skin', 'Blood red', 'Medium size', '10-12cm length']
    },
    {
      id: 5,
      name: 'Armour S18',
      subtitle: 'Premium Heat Variety',
      description: 'Mid spicy with thick skin and slight wrinkle. Whole pods for premium presentation.',
      image: '/armour_s18.jpg',
      heatLevel: '40,000-50,000 SHU',
      color: '40-60 ASTA',
      moisture: '≤14%',
      origin: 'Guntur, Andhra Pradesh',
      specifications: ['Thick skin', 'Whole pods', 'Slight wrinkle', 'Mid pungency']
    },
    {
      id: 6,
      name: 'Shark S21',
      subtitle: 'Premium Heat Variety',
      description: 'High spicy with thin skin. Excellent Teja alternative with superior quality.',
      image: '/shark_s21.jpg',
      heatLevel: '60,000-70,000 SHU',
      color: '60-70 ASTA',
      moisture: '≤14%',
      origin: 'Guntur, Andhra Pradesh',
      specifications: ['Thin skin', 'Whole pods', 'Teja alternative', 'High pungency']
    }
  ],
  processingFormats: [
    {
      id: 1,
      title: 'Whole Dry',
      description: 'With or without stem for maximum flavor and texture preservation',
      icon: 'Package'
    },
    {
      id: 2,
      title: 'Stemless',
      description: 'Manually removed with precision for premium presentation',
      icon: 'Scissors'
    },
    {
      id: 3,
      title: 'Stemcut',
      description: 'Machine-chopped stems with caps remaining for efficiency',
      icon: 'Zap'
    },
    {
      id: 4,
      title: 'Powdered',
      description: 'Fine ground chilli powder for culinary applications',
      icon: 'Sparkles'
    }
  ],
  whyChooseUs: [
    {
      id: 1,
      title: 'Direct Farm Sourcing',
      description: 'Working directly with farmers in Guntur & Nagpur for quality assurance',
      icon: 'Leaf'
    },
    {
      id: 2,
      title: 'ISO Certified',
      description: 'International quality standards with stringent laboratory testing',
      icon: 'Award'
    },
    {
      id: 3,
      title: 'Timely Export',
      description: 'Efficient logistics with full supply chain documentation',
      icon: 'Truck'
    },
    {
      id: 4,
      title: 'Flexible Packaging',
      description: '5-40 kg options in carton, jute, or PP bags with custom solutions',
      icon: 'Package'
    },
    {
      id: 5,
      title: 'Quality Assurance',
      description: 'FSSAI certified with complete traceability and lab analysis',
      icon: 'Shield'
    },
    {
      id: 6,
      title: '40+ Years Heritage',
      description: 'Established in 1984 with unwavering commitment to excellence',
      icon: 'Clock'
    }
  ],
  stats: {
    years: 40,
    countries: 50,
    clients: 1000,
    capacity: 1000
  },
  offices: [
    {
      location: 'Head Office',
      city: 'Nagpur, Maharashtra',
      role: 'Operations & Trading'
    },
    {
      location: 'Branch Office',
      city: 'Guntur, Andhra Pradesh',
      role: 'Sourcing & Processing'
    }
  ]
};
